import React from 'react';
import ProjectCard from '../components/ProjectCard';
import './Projects.css';

const Projects: React.FC = () => {
  const projects = [
    {
      title: 'E-Commerce Platform',
      description: 'A full-stack e-commerce platform built with React, Node.js, and MongoDB.',
      link: 'https://github.com/yourusername/ecommerce',
      tags: ['React', 'Node.js', 'MongoDB', 'Express'],
      image: '/project-ecommerce.jpg'
    },
    {
      title: 'Task Management App',
      description: 'A real-time task management application with drag-and-drop functionality.',
      link: 'https://github.com/yourusername/task-manager',
      tags: ['React', 'TypeScript', 'Firebase'],
      image: '/project-taskmanager.jpg'
    },
    {
      title: 'Weather Dashboard',
      description: 'A weather dashboard that displays current and forecasted weather data.',
      link: 'https://github.com/yourusername/weather-app',
      tags: ['React', 'API Integration', 'CSS3'],
      image: '/project-weather.jpg'
    }
  ];

  return (
    <section className="projects-page">
      <div className="projects-container">
        <h2 className="section-title">My Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects; 